import { Directive, ElementRef, Input } from "@angular/core";
import { BehaviorSubject, filter, Subject, takeUntil } from "rxjs";


@Directive({
    selector: '[gridItem]'
})
export class GridItemDirective {
    readonly #destroy = new Subject<void>()
    readonly colSpanSubject = new BehaviorSubject<number>(1)
    @Input() get colSpan() {
        return this.colSpanSubject.value
    }
    set colSpan(value) {
        this.colSpanSubject.next(value)
    }

    get #element() {
        return this._elementRef.nativeElement
    }

    constructor(
        private readonly _elementRef: ElementRef<HTMLElement>
    ) {

    }



    ngAfterViewInit() {
        this.colSpanSubject.pipe(
            filter(Boolean),
            takeUntil(this.#destroy)
        )
            .subscribe((colSpan) => {

                this.#element.classList.forEach(className => {
                    if (className.startsWith('grid-item')) {
                        this.#element.classList.remove(className)
                    }
                })

                this.#element.classList.add('grid-item-' + colSpan);
            })
    }




    ngOnDestroy() {
        this.#destroy.next()
        this.#destroy.complete()
    }


}